import { post as apiPost, TYPE_BROOKLYN } from 'api-client'
import strictUriEncode from 'strict-uri-encode'
import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'

export const TOTAL_VOTES_THRESHOLD = 25

export const VOTE_DIRECTION_DOWN = 0
export const VOTE_DIRECTION_UP = 1
export const VOTE_DIRECTION_LOVE = 2

export const VOTE_DIRECTIONS = {
  DOWN: VOTE_DIRECTION_DOWN,
  UP: VOTE_DIRECTION_UP,
  LOVE: VOTE_DIRECTION_LOVE,
}

export const VOTE_SIZE_SMALL = 'small'
export const VOTE_SIZE_MEDIUM = 'medium'
export const VOTE_SIZE_LARGE = 'large'

const SCHEMA = {
  id: null,
  _dataError: false,
  vote: null,
}

export async function recommend (options) {
  const { id, auth, vote } = options
  try {
    const res = await apiPost(`v2/user/node/${strictUriEncode(id)}/vote`, { vote }, { auth }, TYPE_BROOKLYN)
    return handleRecommendResponse(res, id, vote)
  } catch (e) {
    return handleRecommendResponse({}, id, vote, true)
  }
}

function handleRecommendResponse (res, id, vote, _dataError) {
  return createModel(id, vote, _dataError)
}

function createModel (id, vote, _dataError) {
  return _assign(_cloneDeep(SCHEMA), {
    id,
    _dataError,
    vote,
  })
}
